<template>
  <v-main class="primary">
    <transition name="fade" mode="out-in">
      <loader-component v-if="loading"></loader-component>
      <router-view v-else></router-view>
    </transition>
  </v-main>
</template>
<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition-duration: 0.3s;
  transition-property: opacity;
  transition-timing-function: ease;
}

.fade-enter,
.fade-leave-active {
  opacity: 0;
}
</style>
<script>
import { mapActions, mapMutations, mapGetters } from 'vuex'
import LoaderComponent from '../../components/LoaderComponent.vue'
import { MODULOS } from '@src/perfiles'

export default {
  components: {
    LoaderComponent,
  },

  async created() {
    this.ENABLE_LOADER()
    this.setThemeByModule(MODULOS.EQUIPAMIENTO)
    await this.fetchTiposItem()
    await this.fetchEquipo()
    await this.fetchEstatusEquipamiento()

    this.DISABLE_LOADER()
  },

  computed: {
    ...mapGetters({
      loading: 'getLoader',
    }),
  },

  methods: {
    ...mapActions('personal', ['fetchPersonal']),
    ...mapActions('tipoItem', ['fetchTiposItem']),
    ...mapActions('equipo', ['fetchEquipo']),
    ...mapActions('estatusEquipamiento', ['fetchEstatusEquipamiento']),
    ...mapMutations(['DISABLE_LOADER', 'ENABLE_LOADER']),
  },
}
</script>
